import React from 'react';
import {Button, Col, Container, Form, Image, Row} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/free-solid-svg-icons";
import {useSearchParams} from "react-router-dom";
import {toast} from "react-toastify";

const downloadInstaller = (type) => {
    var installerUrl = '';
    if (type === 'win'){
        installerUrl = 'https://feitui.tos-cn-beijing.volces.com/%E5%89%AA%E6%98%A0%E8%8D%89%E7%A8%BF%E5%A4%A7%E5%B8%88%20Setup%201.0.0.exe';
    }else {
        installerUrl = 'https://feitui.tos-cn-beijing.volces.com/%E5%89%AA%E6%98%A0%E8%8D%89%E7%A8%BF%E5%A4%A7%E5%B8%88-1.0.0-universal.dmg.zip';
    }
  const a = document.createElement('a');
  a.href = installerUrl;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

function JianYingAssistant() {
  const [searchParams] = useSearchParams();
  const draftId = searchParams.get('draftId');
  
  // 您可以在组件中使用draftId参数了
  // console.log('draftId:', draftId);

    const copyText = (text) => {
        navigator.clipboard.writeText(text);
        toast.success('已复制到剪贴板！')
    }
    return (
        <Container className="mt-5 mb-5" style={{'--bs-border-radius': '0.6rem'}}>
            {/* Header */}
            <Row>
                <Col className="text-center">
                    <h2 style={{
                        background: 'url("/images/agent/top_bg.png")',
                        backgroundSize: 'cover',
                        color: 'white',
                        padding: '10px',
                        fontWeight: 'bold',
                        borderTopLeftRadius: '0.6rem',
                        borderTopRightRadius: '0.6rem',
                        paddingTop: '40px',
                        paddingBottom: '20px',
                    }}>
                        剪映草稿大师
                    </h2>
                </Col>
            </Row>

            {/* Download and Draft Sections */}
            <Row className="mt-4">
                <Col md={6}>
                    <div className="p-4 bg-dark rounded mb-2 text-start"
                         style={{borderTopColor: '#00bfff', borderTopWidth: '10px', borderTopStyle: 'solid',}}>
                        <div className="d-flex flex-column align-items-start mb-3">
                            <Image src={'/images/agent/label_1.svg'} width={'48px'}
                                   style={{marginBottom: '1rem'}}></Image>
                            <span style={{color: "#B4BFC5", fontSize: '18px'}}>下载草稿大师</span>
                        </div>
                        <p style={{color: "#798992"}}>下载并安装剪映草稿大师客户端，开启智能视频创作之旅。支持Windows和Mac系统，一键安装即可使用。</p>
                        <Row>
                            <Col xl={6}>
                                <Button className="mb-2"
                                        onClick={() => {
                                            downloadInstaller("win");
                                        }}
                                        style={{
                                            color: '#1A2027',
                                            width: '100%',
                                            backgroundColor: '#02C8E3',
                                            border: 'none',
                                            borderRadius: '5px',
                                            padding: '10px 20px',
                                            textAlign: 'left',
                                            alignItems: 'center',
                                            fontSize: '16px',
                                            display: 'flex',
                                        }}>
                                    <Image src={'/images/agent/icon_download.svg'}
                                           style={{width: '30px', marginRight: '10px'}}/>
                                    <span style={{display: "flex", flexDirection: 'column'}}>
                                         <strong>Windows版本</strong>
                                    <span style={{fontSize: '14px'}}>
                                    兼容Win8.1以上版本
                                    </span>
                                    </span>
                                </Button>
                            </Col>
                            <Col xl={6}>
                                <Button className="mb-2"
                                        onClick={() => {
                                            //download file
                                            downloadInstaller("mac");
                                        }}
                                        style={{
                                            color: '#1A2027',
                                            width: '100%',
                                            backgroundColor: '#5976D4',
                                            border: 'none',
                                            borderRadius: '5px',
                                            padding: '10px 20px',
                                            textAlign: 'left',
                                            alignItems: 'center',
                                            fontSize: '16px',
                                            display: 'flex',
                                        }}>
                                    <Image src={'/images/agent/icon_download.svg'}
                                           style={{width: '30px', marginRight: '10px'}}/>
                                    <span style={{display: "flex", flexDirection: 'column'}}>
                                         <strong>Mac版本</strong>
                                    <span style={{fontSize: '14px'}}>
                                    支持macOS
                                    </span>
                                    </span>

                                </Button>
                            </Col>
                        </Row>


                    </div>
                </Col>
                <Col md={6}>
                    <div className="p-4 bg-dark rounded mb-2 text-start"
                         style={{borderTopColor: '#00bfff', borderTopWidth: '10px', borderTopStyle: 'solid'}}>
                        <div className="d-flex flex-column align-items-start mb-3">
                            <Image src={'/images/agent/label_2.svg'} width={'48px'}
                                   style={{marginBottom: '1rem'}}></Image>
                            <span style={{color: "#B4BFC5", fontSize: '18px'}}>剪映草稿导出</span>
                        </div>
                        <p style={{color: "#798992"}}>复制草稿地址到客户端首页，即可创建剪映草稿，快速生成高质量视频，提升创作效率。</p>
                        <Form.Group controlId="formDraftAddress">
                            <Form.Label style={{color: "#B4BFC5"}}>草稿地址：</Form.Label>
                            <div className="d-flex">
                                <Form.Control type="text" placeholder="未识别到草稿地址，请先生成草稿" value={draftId?('https://feituiai.com/JianYingAssistant?draftId='+draftId): ''} readOnly={ true}/>
                                {draftId && <Button onClick={() => copyText('https://feituiai.com/JianYingAssistant?draftId='+draftId)} style={{
                                    marginLeft: '10px',
                                    backgroundColor: '#252D36',
                                    color: '#02C8E3',
                                    border: 'none',
                                    flexShrink: 0,
                                }}>
                                    复制
                                </Button>}
                            </div>
                        </Form.Group>
                    </div>

                </Col>
            </Row>

            {/* Product Introduction */}
            <Row className="mt-5">
                <Col className="text-center">
                    <Col className="d-flex justify-content-center align-items-center text-center">
                        <span style={{
                            display: 'inline-block',
                            background: 'linear-gradient(to left, #00bfff, #262C34)',
                            width: '50px',
                            borderRadius: '10px',
                            height: '5px'
                        }}></span>
                        <h4 style={{color: '#00bfff', fontWeight: 'bold', margin: '10px 10px'}}>产品介绍</h4>
                        <span style={{
                            display: 'inline-block',
                            background: 'linear-gradient(to right, #00bfff, #262C34)',
                            width: '50px',
                            borderRadius: '10px',
                            height: '5px'
                        }}></span>
                    </Col>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col md={12} className="p-4 bg-dark text-white rounded"
                     style={{
                         borderTopColor: '#00bfff',
                         alignItems: "start",
                         textAlign: 'start',
                         borderTopWidth: '10px',
                         borderTopStyle: 'solid'
                     }}>
                    <div className="d-flex flex-column align-items-start mb-3">
                        <Image src={'/images/agent/label_3.svg'} width={'48px'}
                               style={{marginBottom: '1rem'}}></Image>
                        <span style={{color: "#B4BFC5", fontSize: '18px'}}>剪映草稿大师</span>
                    </div>
                    <p style={{
                        color: "#798992",
                        fontSize: '14px',
                        lineHeight: '1.5'
                    }}>专业的视频创作辅助工具，让您的视频制作更加高效便捷。支持一键导入剪映草稿，智能模板管理、云端同步备份等功能，让创作更轻松。</p>
                    <Button variant="primary" style={{
                        backgroundColor: '#252D36',
                        color: '#02C8E3',
                        border: 'none',
                        borderRadius: '5px',
                        padding: '8px',
                        fontSize: '14px',
                        marginRight: '20px',
                        marginBottom: '10px'
                    }}><FontAwesomeIcon icon={faCheck}></FontAwesomeIcon> 一键导入剪映草稿</Button>
                    <Button variant="primary" style={{
                        backgroundColor: '#252D36',
                        color: '#02C8E3',
                        border: 'none',
                        borderRadius: '5px',
                        fontSize: '14px',
                        padding: '8px',
                        marginRight: '20px',
                        marginBottom: '10px'
                    }}><FontAwesomeIcon icon={faCheck}></FontAwesomeIcon> 智能模板管理</Button>
                    <Button variant="primary" style={{
                        backgroundColor: '#252D36',
                        color: '#02C8E3',
                        border: 'none',
                        borderRadius: '5px',
                        fontSize: '14px',
                        padding: '8px',
                        marginBottom: '10px'
                    }}><FontAwesomeIcon icon={faCheck}></FontAwesomeIcon> 云端同步备份</Button>
                </Col>
            </Row>

            {/* Our Advantages */}
            <Row className="mt-5">
                <Col className="d-flex justify-content-center align-items-center text-center">
                    <span style={{
                        display: 'inline-block',
                        background: 'linear-gradient(to left, #00bfff, #262C34)',
                        width: '50px',
                        borderRadius: '10px',
                        height: '5px'
                    }}></span>
                    <h4 style={{color: '#00bfff', fontWeight: 'bold', margin: '10px 10px'}}>我们的优势</h4>
                    <span style={{
                        display: 'inline-block',
                        background: 'linear-gradient(to right, #00bfff, #262C34)',
                        width: '50px',
                        borderRadius: '10px',
                        height: '5px'
                    }}></span>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col md={3}>
                    <div className="p-4 bg-dark text-white rounded" style={{marginTop: '10px', marginBottom: '10px'}}>
                        <h3 style={{fontSize: '2rem', marginBottom: '0.5rem', color: '#00bfff'}}>100+</h3>
                        <p style={{fontSize: '1rem', marginBottom: '0.5rem', color: '#00bfff'}}>专业模板</p>
                        <small style={{color: '#a0a0a0'}}>海量优质模板，满足各类创作需求</small>
                    </div>
                </Col>
                <Col md={3}>
                    <div className="p-4 bg-dark text-white rounded" style={{marginTop: '10px', marginBottom: '10px'}}>
                        <h3 style={{fontSize: '2rem', marginBottom: '0.5rem', color: '#00bfff'}}>50万+</h3>
                        <p style={{fontSize: '1rem', marginBottom: '0.5rem', color: '#00bfff'}}>活跃用户</p>
                        <small style={{color: '#a0a0a0'}}>庞大的用户群体，持续更新优化</small>
                    </div>
                </Col>
                <Col md={3}>
                    <div className="p-4 bg-dark text-white rounded" style={{marginTop: '10px', marginBottom: '10px'}}>
                        <h3 style={{fontSize: '2rem', marginBottom: '0.5rem', color: '#00bfff'}}>24/7</h3>
                        <p style={{fontSize: '1rem', marginBottom: '0.5rem', color: '#00bfff'}}>技术支持</p>
                        <small style={{color: '#a0a0a0'}}>全天候技术支持，解决您的困扰</small>
                    </div>

                </Col>
                <Col md={3}>
                    <div className="p-4 bg-dark text-white rounded" style={{marginTop: '10px', marginBottom: '10px'}}>
                        <h3 style={{fontSize: '2rem', marginBottom: '0.5rem', color: '#00bfff'}}>99.9%</h3>
                        <p style={{fontSize: '1rem', marginBottom: '0.5rem', color: '#00bfff'}}>服务可用性</p>
                        <small style={{color: '#a0a0a0'}}>稳定可靠的服务，保障创作无忧</small>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default JianYingAssistant;